export default __webpack_public_path__ + "static/EoW_Horizontal_logo_TM_transparent_1-42f52d40712ff9e16aa5954c817cafc8.svg";